// extracted by mini-css-extract-plugin
export default {"element":"Magnifier__element___Zym9Y","image":"Magnifier__image___Nr49v"};